import React from 'react'
import styles from './styles.module.css'

export const SectionCard = ({ title, children, noPadding, headerAction, style }) => (
  <div className={styles.sectionCard} style={style}>
    <div className={styles.sectionCardHeader}>
      <span className={styles.sectionCardTitle}>{title}</span>
      {headerAction ? (
        <div className={styles.sectionCardHeaderAction}>{headerAction}</div>
      ) : null}
    </div>
    <div className={noPadding ? '' : styles.sectionCardBody}>{children}</div>
  </div>
)
